import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { List } from 'immutable';
import { DialogService } from '../../../dialog/dialog.service';
import { NavigationService } from '../../../navigation/navigation.service';
import {
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';

@Component({
  selector: 'app-payments-info-dialog',
  templateUrl: './payments-info-dialog.component.html',
  styleUrls: ['./payments-info-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentsInfoDialogComponent implements OnInit {
  @Input() dialogType = 'payments-info-dialog';
  @Input() headerLabel: string;
  @Input() confirmLabel: string;
  @Input() confirmUrl: string;
  @Input() introLabel: string;
  @Input() description: string;
  @Input() listItems: List<string>;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  @Output() onConfirm: EventEmitter<void> = new EventEmitter<void>();
  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private _dialogService: DialogService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _navigationService: NavigationService
  ) {}

  ngOnInit() {}

  onPrimaryAction() {
    this.onConfirm.emit();

    this._navigationService.goToExternalUrl(this.confirmUrl, true);
  }
}
